export default {
  // 基础菜单
  'menu.login': '登录',

  // 地址管理
  'menu.address': '地址管理',
  'menu.address.list': '地址列表',
  'menu.address.groups': '地址分组',
  'menu.address.import-export': '导入导出',

  // 任务中心
  'menu.task': '任务中心',
  'menu.task.gas': 'Gas 分发',
  'menu.task.gas.list': '任务列表',
  'menu.task.gas.create': '创建任务',
  'menu.task.gas.history': '任务历史',
  'menu.task.collection': '资产归集',
  'menu.task.collection.list': '任务列表',
  'menu.task.collection.create': '创建归集',
  'menu.task.collection.history': '归集记录',

  // 交易管理
  'menu.trading': '交易管理',
  'menu.trading.create': '创建交易',
  'menu.trading.history': '交易记录',
  'menu.trading.strategies': '策略管理',

  // Token 管理
  'menu.token': 'Token 管理',
  'menu.token.list': 'Token 列表',
  'menu.token.create': '创建 Token',

  // 系统设置
  'menu.system': '系统设置',
  'menu.system.audit-logs': '审计日志',
  'menu.system.config': '系统配置',

  // 账户相关
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.logout': '退出登录',
};
